var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"cp","title":"cabo.party"}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Home',
          icon: _vm.$icons.cactus,
          path: '/',
        }}}),_c('sidebar-item',{attrs:{"link":{
          icon: _vm.$icons.sun,
          name: 'Today',
          path: '/los-cabos-events-today',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Clubs',
          icon: _vm.$icons.disc,
          path: '/los-cabos-clubs',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Calendar',
          icon: _vm.$icons.calendar,
          path: '/los-cabos-mexico-event-calendar',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Dinner',
          icon: _vm.$icons.utensils,
          path: '/los-cabos-dinner-table-reservations',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Nightlife',
          icon: _vm.$icons.moon,
          path: '/los-cabos-nightlife',
        }}}),_c('sidebar-item',{attrs:{"link":{
          icon: _vm.$icons.astronaut,
          name: 'Travel & Concierge',
          path: '/los-cabos-concierge-services',
        }}})],1)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('Transition',{attrs:{"name":"fade","appear":""}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }